import { Language } from "../types/types";

interface NavigationNames {
  home: string;
  about: string;
  company: string;
  team: string;
  documents: string;
  services: string;
  courses: string;
  apply:string;
  tig: string;
  mag: string;
  mig: string;
  mma: string;
  qualification: string;
  companies: string;
  unemployed: string;
  stars: string;
  howToChoose: string;
  short: string;
  sertification: string;
  learner: string;
  faq: string;
  contacts: string;
}

const navigationNames: Record<Language, NavigationNames> = {
  lv: {
    home: "Sākums",
    about: "Par mums",
    company: "Uzņēmums",
    team: "Mūsu komanda",
    documents: "Dokumenti",
    services: "Metināšanas pakalpojumi",
    courses: "Kursi",
    apply: "Pieteikties kursiem",
    tig: "TIG",
    mag: "MAG",
    mig: "MIG",
    mma: "MMA",
    qualification: "Kvalifikācijas celšana",
    companies: "Uzņēmumiem",
    unemployed: "Bezdarbniekiem",
    stars: "Mācības ar ES fondu atbalstu",
    howToChoose: "Kā izvēlēties veidu",
    short: "40 stundu kursi",
    sertification: "Sertifikācija",
    learner: "Izglītojamajiem",
    faq: "BUJ",
    contacts: "Kontakti",
  },
  en: {
    home: "Home",
    about: "About Us",
    company: "Company",
    team: "Our Team",
    documents: "Documents",
    services: "Welding Services",
    courses: "Courses",
    apply: "Apply for courses",
    tig: "TIG",
    mag: "MAG",
    mig: "MIG",
    mma: "MMA",
    qualification: "Enhancing Qualifications",
    companies: "For Companies",
    unemployed: "For the Unemployed",
    stars: "Training with EU Fund Support",
    howToChoose: "How to Choose the Type",
    short: "40-hour courses",
    sertification: "Certification",
    learner: "For Learners",
    faq: "FAQ",
    contacts: "Contacts",
  },
  ru: {
    home: "Главная",
    about: "О нас",
    company: "Компания",
    team: "Наша команда",
    documents: "Документы",
    services: "Сварочные услуги",
    courses: "Курсы",
    apply: "Записаться",
    tig: "TIG",
    mag: "MAG",
    mig: "MIG",
    mma: "MMA",
    qualification: "Повышение квалификации",
    companies: "Для компаний",
    unemployed: "Для безработных",
    stars: "Обучение при поддержке фондов ЕС",
    howToChoose: "Как выбрать тип",
    short: "40-часовые курсы",
    sertification: "Сертификация",
    learner: "Для учащихся",
    faq: "Вопросы и ответы",
    contacts: "Контакты",
  },
};

export default navigationNames;
